module.exports = __webpack_public_path__ + "media/images/plus-icon-a42ef6e7.svg";